import React, { useState, useEffect, useCallback } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import '../css/Carrusel.css';

const imagesData = [
  { id: 1, url: 'https://firebasestorage.googleapis.com/v0/b/elretodecarmen-3a0ae.firebasestorage.app/o/imagenes%20presentaci%C3%B3n%2F01.png?alt=media&token=06ffbbf9-ef86-4d83-b0c1-f7dc83e40a11', alt: 'Página 1' },
  { id: 2, url: 'https://firebasestorage.googleapis.com/v0/b/elretodecarmen-3a0ae.firebasestorage.app/o/imagenes%20presentaci%C3%B3n%2F02.png?alt=media&token=5ac6dec8-8438-4030-960b-b5ce44a0040b', alt: 'Página 2' },
  { id: 3, url: 'https://firebasestorage.googleapis.com/v0/b/elretodecarmen-3a0ae.firebasestorage.app/o/imagenes%20presentaci%C3%B3n%2F03.png?alt=media&token=70db7c63-2c41-4d85-ab6a-91a2d0aebc90', alt: 'Página 3' },
  { id: 4, url: 'https://firebasestorage.googleapis.com/v0/b/elretodecarmen-3a0ae.firebasestorage.app/o/imagenes%20presentaci%C3%B3n%2F04.png?alt=media&token=be8274e9-24dc-405f-935b-609eac1ef9b3', alt: 'Página 4' },
  { id: 5, url: 'https://firebasestorage.googleapis.com/v0/b/elretodecarmen-3a0ae.firebasestorage.app/o/imagenes%20presentaci%C3%B3n%2F05.png?alt=media&token=a9b32f2a-25d9-4ec9-bf8c-688f534b163c', alt: 'Página 5' },
  { id: 6, url: 'https://firebasestorage.googleapis.com/v0/b/elretodecarmen-3a0ae.firebasestorage.app/o/imagenes%20presentaci%C3%B3n%2F06.png?alt=media&token=b880294b-5417-42bf-b787-dc56506fd763', alt: 'Página 6' },
  { id: 7, url: 'https://firebasestorage.googleapis.com/v0/b/elretodecarmen-3a0ae.firebasestorage.app/o/imagenes%20presentaci%C3%B3n%2F07.png?alt=media&token=9286440c-9ad3-4fd4-9a85-f2943b6e73c4', alt: 'Página 7' },
  { id: 8, url: 'https://firebasestorage.googleapis.com/v0/b/elretodecarmen-3a0ae.firebasestorage.app/o/imagenes%20presentaci%C3%B3n%2F08.png?alt=media&token=cb34c587-91dd-4f01-88a6-d82829936c5e', alt: 'Página 8' },
  { id: 9, url: 'https://firebasestorage.googleapis.com/v0/b/elretodecarmen-3a0ae.firebasestorage.app/o/imagenes%20presentaci%C3%B3n%2F09.png?alt=media&token=0e2797dd-7942-4fd2-8e46-bca3b6d51615', alt: 'Página 9' },
  { id: 10, url: 'https://firebasestorage.googleapis.com/v0/b/elretodecarmen-3a0ae.firebasestorage.app/o/imagenes%20presentaci%C3%B3n%2F10.png?alt=media&token=34b15062-a900-4386-996e-49ee87ba4414', alt: 'Página 10' },
  { id: 11, url: 'https://firebasestorage.googleapis.com/v0/b/elretodecarmen-3a0ae.firebasestorage.app/o/imagenes%20presentaci%C3%B3n%2F11.png?alt=media&token=dd2f920a-8591-42bf-b220-e454f5d8c539', alt: 'Página 11' },
];

const Carrusel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const nextSlide = useCallback(() => {
    setCurrentIndex((prev) => (prev === imagesData.length - 1 ? 0 : prev + 1));
  }, []);

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? imagesData.length - 1 : prev - 1));
  };

  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(nextSlide, 6000);
    return () => clearInterval(interval);
  }, [nextSlide, isPaused]);

  return (
    <div className="custom-carousel-wrapper">
      <div 
        className="carousel-main-container"
        onMouseDown={() => setIsPaused(true)}
        onMouseUp={() => setIsPaused(false)}
        onMouseLeave={() => setIsPaused(false)}
        onTouchStart={() => setIsPaused(true)}
        onTouchEnd={() => setIsPaused(false)}
      >
        <div className="slides-viewport">
          {imagesData.map((img, index) => (
            <div 
              key={img.id} 
              className={`slide-item ${index === currentIndex ? 'active' : ''}`}
            >
              <img src={img.url} alt={img.alt} className="carousel-image" />
            </div>
          ))}
        </div>

        <div className="instagram-bars">
          {imagesData.map((_, index) => (
            <div key={index} className="bar-bg">
              <div className={`bar-fill ${index === currentIndex ? 'filling' : index < currentIndex ? 'completed' : ''}`} />
            </div>
          ))}
        </div>

        <button className="btn-nav left" onClick={(e) => { e.stopPropagation(); prevSlide(); }}>
          <ChevronLeft size={30} />
        </button>
        <button className="btn-nav right" onClick={(e) => { e.stopPropagation(); nextSlide(); }}>
          <ChevronRight size={30} />
        </button>
      </div>

      <div className="counter-badge">
        {currentIndex + 1} / {imagesData.length}
      </div>
    </div>
  );
};

export default Carrusel;